import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 0H8C3.6 0 0 3.519 0 7.82s3.6 7.82 8 7.82h8c4.4 0 8-3.519 8-7.82S20.4 0 16 0m0 13.686H8c-3.3 0-6-2.64-6-5.866s2.7-5.865 6-5.865h8c3.3 0 6 2.639 6 5.865s-2.7 5.866-6 5.866M8 3.91c-2.2 0-4 1.76-4 3.91s1.8 3.91 4 3.91 4-1.76 4-3.91-1.8-3.91-4-3.91m0 5.865c-1.1 0-2-.88-2-1.955s.9-1.955 2-1.955 2 .88 2 1.955-.9 1.955-2 1.955"
    }, null, -1)
  ]))]))
}
export default { render: render }